import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { LanguageCode, LocalizationStyle } from "types/styles";

import default_en from "./translations/default_en.json";
import sweeps_en from "./translations/sweeps_en.json";
import { LocalizationDictionary } from "./types";

export const defaultNS = "default" as const;

export const resources = {
  en: {
    default: default_en,
    sweeps: sweeps_en,
  },
  es: {},
} as const satisfies Record<
  LanguageCode,
  Partial<Record<LocalizationStyle, LocalizationDictionary>>
>;

i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  ns: ["default", "sweeps"],
  defaultNS,
  resources,
  debug: process.env.NODE_ENV === "development",
});

export default i18n;
